module.exports = __webpack_public_path__ + "media/empty-states/tickets-c7ef04c1.png";